import React from "react";
import { FaMedal } from "react-icons/fa"; // Import medal icon

const SelectedActorsScores = ({ gameStatus, podium }) => {
  // Récupérer les acteurs sélectionnés
  const selectedActors = gameStatus.list_selected_actors;

  let score_unit = gameStatus.decision_metric_id;

  // Récupérer les scores des acteurs sélectionnés
  let actorScores = selectedActors.map((actor) => {
    const actorData = gameStatus.score_dic[actor];
    return {
      name: actorData.name,
      icon: actorData.icon,
      value: actorData.value,
      money: 0, // Initialisation du montant distribué
    };
  });

  // Trier les acteurs par score décroissant
  actorScores.sort((a, b) => b.value - a.value);
  if (podium) {
    // Exclude "agence-eau" from the podium
    actorScores = actorScores.filter(
      (actor) => actor.name !== "Agence de l'eau"
    ).slice(0, 3);

    // Assign medals based on ranking
    const medals = ["gold", "silver", "bronze"];
    actorScores.forEach((actor, index) => {
      if (index > 0 && actor.value === actorScores[index - 1].value) {
        actor.medal = actorScores[index - 1].medal; // Same medal for ties
      } else {
        actor.medal = medals[index] || null; // Assign medal or null if out of range
      }
    });
  }

  // Répartition du budget.
  // `decision_metric_id` n'est PAS fiable (cf. acgSummary.budgetScoreId) :
  // GameConfigurator ne l'envoie pas à /init_game, qui retombe sur 'money'. Une
  // partie dont le budget est 'vote' et qui ne traîne pas de score 'money'
  // résiduel faisait planter cet écran — page blanche en fin d'atelier, devant
  // la salle. Le budget est un ornement ici : son absence n'efface qu'un
  // décompte.
  let remainingMoney = gameStatus.score_dic?.[score_unit]?.value
    ?? gameStatus.score_dic?.vote?.value
    ?? 0;
  while (remainingMoney > 0) {
    let moneyDistributed = false;
    for (let i = 0; i < actorScores.length; i++) {
      if (remainingMoney > 0) {
        actorScores[i].money += 1;
        remainingMoney -= 1;
        moneyDistributed = true;
      }
    }
    // Si aucun argent n'a été distribué, on sort de la boucle
    if (!moneyDistributed) break;
  }

  return (
    <div className="scoreboard-actors-container">
      {!podium ? (
        <h2 className="scoreboard-actors-title">
          Budget disponible : {gameStatus.score_dic[score_unit].value}
        </h2>
      ) : (
        <h2 className="scoreboard-actors-title">Podium des acteurs</h2>
      )}
      <div className="scoreboard-actors-list">
        {actorScores.map((actor, index) => (
          <div key={index} className="scoreboard-actors-item">
            <div className="scoreboard-actors-item-left-container">
              <img
                src={actor.icon}
                alt={actor.name}
                className="scoreboard-actors-icon"
              />
              <span className="scoreboard-actors-name">{actor.name}</span>
            </div>
            <div className="scoreboard-actors-item-right-container">
              {podium && actor.medal ? (
                <FaMedal
                  className={`scoreboard-actors-medal scoreboard-actors-medal-${actor.medal}`}
                  title={actor.medal}
                />
              ) : (
                <span className="scoreboard-actors-value">{actor.money}</span>
              )}
              {podium && !actor.medal && (
                <span className="scoreboard-actors-detail">
                  ({actor.value} pts)
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectedActorsScores;
